import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.POSTBACK_HISTORY_START_LOADING,
    success: AppConstants.POSTBACK_HISTORY_SUCCESS,
    fail: AppConstants.POSTBACK_HISTORY_FAIL
};
const PostbackHistoryActions = {
    getListHistoryPostbacks(params, callback, events = defEvents) {
        dispatch({
            type: events.before
        });

        return api.searchPostbackQueue(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                return data.response || {};
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type  : events.fail,
                        error : err.error
                    });
                });
            });
    }
};

export default PostbackHistoryActions;
